import { WawiListElement } from "./WawiListElement";

export enum MappingType {
    Manual = 0,
    FieldSpecific = 1
}

export class WawiList {
    constructor(
        public id: string,
        public listName: string,
        public key: string,
        public value: string,
        public isMapping: boolean,
        public fields: WawiListElement[],
        public visible?: boolean,
        public mappingType: MappingType = MappingType.Manual,
        public createNullValues: boolean = false,
        public mappingFields: string[] = [],
        public execute: boolean = true,
        public sourceValuesCatalogId: string = null,
        public isGlobal: boolean = false
    ) {
    }
}
